import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import translations_en from './locales/en/translation.json';
import translations_fr from './locales/fr/translation.json';

// the translations
const resources = {
    en: { translation: translations_en },
    fr: { translation: translations_fr },
};

i18n.use(initReactI18next)
    .init({
        resources,
        lng: "fr",
        debug: false,
        fallbackLng: "en",
        interpolation: {
            escapeValue: false
        },
        ns: "translation",
        defaultNS: "translation"
    });

export default i18n;